import { ArchiveRefreshOutlineIcon } from './ArchiveRefreshOutlineIcon';

/**
 * author: Colton Wiscombe
 * id AFCA7BDE-7A75-4C5E-BC61-32662E4B011C
 * name archive-refresh-outline
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/archive-refresh-outline.svg
 * tags
 */
export const BoxRefreshOutlineIcon = ArchiveRefreshOutlineIcon;
export default BoxRefreshOutlineIcon